import { Controller } from "@hotwired/stimulus"

// The Tally instrument question defaults from its `instrument` hidden field.
// Respondents can still change the answer; Tally filters campuses accordingly.
export default class extends Controller {
  static targets = ["frame"]

  select(event) {
    const instrument = { electric: "Guitar Điện - 7 Cơ sở", bass: "Guitar Bass - 4 cơ sở" }[event.params.instrument]
    if (!instrument || !this.hasFrameTarget) return

    const url = new URL(this.frameTarget.getAttribute("src") || this.frameTarget.dataset.tallySrc)
    if (url.searchParams.get("instrument") === instrument) return

    url.searchParams.set("instrument", instrument)
    url.searchParams.set("source", event.params.instrument === "bass" ? "guitar_bass_website" : "electric_guitar_website")
    this.frameTarget.dataset.tallySrc = url.toString()
    this.frameTarget.src = url.toString()
  }
}
